/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type ListDistributionPluginsSecurity = {
  projectSlugHeaderGramProject?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type ListDistributionPluginsRequest = {
  skillId: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type ListDistributionPluginsSecurity$Outbound = {
  "project_slug_header_Gram-Project"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const ListDistributionPluginsSecurity$outboundSchema: z.ZodMiniType<
  ListDistributionPluginsSecurity$Outbound,
  ListDistributionPluginsSecurity
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function listDistributionPluginsSecurityToJSON(
  listDistributionPluginsSecurity: ListDistributionPluginsSecurity,
): string {
  return JSON.stringify(
    ListDistributionPluginsSecurity$outboundSchema.parse(
      listDistributionPluginsSecurity,
    ),
  );
}

/** @internal */
export type ListDistributionPluginsRequest$Outbound = {
  skill_id: string;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const ListDistributionPluginsRequest$outboundSchema: z.ZodMiniType<
  ListDistributionPluginsRequest$Outbound,
  ListDistributionPluginsRequest
> = z.pipe(
  z.object({
    skillId: z.string(),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      skillId: "skill_id",
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
    });
  }),
);

export function listDistributionPluginsRequestToJSON(
  listDistributionPluginsRequest: ListDistributionPluginsRequest,
): string {
  return JSON.stringify(
    ListDistributionPluginsRequest$outboundSchema.parse(
      listDistributionPluginsRequest,
    ),
  );
}
